module.exports = __webpack_public_path__ + "media/reskin-images/icon--export-2429e134.svg";